import React, { memo } from 'react';
import SearchButton from './SearchButton';
import SearchInput from './SearchInput';
import SearchResults from './SearchResults';

/**
 * Search panel component that floats on top of the chat area
 * Combines search button, input, and results navigation
 */
const SearchPanel = memo(({ 
  showSearch, 
  setShowSearch, 
  searchQuery, 
  setSearchQuery, 
  searchResults, 
  currentResultIndex, 
  isSearching,
  goToNextResult, 
  goToPrevResult, 
  handleSearchKeyDown, 
  searchInputRef, 
  clearSearchInput
}) => (
  <div className="sticky top-4 right-0 p-4 pointer-events-none w-full flex justify-end z-10">
    <div className="flex flex-col items-end">
      <SearchButton 
        showSearch={showSearch} 
        setShowSearch={setShowSearch} 
      />
      
      {showSearch && (
        <div className="mt-3 bg-slate-100 dark:bg-neutral-900 text-ui-text-primary p-4 w-72 border border-slate-300 dark:border-neutral-800 pointer-events-auto rounded-xl shadow-lg">
          <div className="flex items-center mb-3">
            <SearchInput
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handleSearchKeyDown={handleSearchKeyDown}
              searchInputRef={searchInputRef}
              clearSearchInput={clearSearchInput}
            />
          </div>
          
          <SearchResults
            searchQuery={searchQuery}
            isSearching={isSearching}
            searchResults={searchResults}
            currentResultIndex={currentResultIndex}
            goToPrevResult={goToPrevResult}
            goToNextResult={goToNextResult}
          />
        </div>
      )}
    </div>
  </div>
));

SearchPanel.displayName = 'SearchPanel';

export default SearchPanel;